import { useState, useEffect } from "react";
import moment from "moment";
import ReactApexChart from "react-apexcharts";

const MessageAnalytics = ({ dataMap }) => {
  const [period, setPeriod] = useState("Yearly");
  const [categories, setCategories] = useState([]);
  const [seriesData, setSeriesData] = useState([]);

  useEffect(() => {
    if (period === "Yearly") {
      const now = moment();
      // Generate last 12 years, oldest first
      const last12Years = [];
      for (let i = 11; i >= 0; i--) {
        last12Years.push(now.clone().subtract(i, "years").year());
      }
      setCategories(last12Years);

      // Map dataMap.Yearly (assumed keyed by year) to array matching categories
      // If dataMap.Yearly is array with values aligned oldest to newest, use directly
      // Otherwise if it's object with years as keys, map accordingly
      if (dataMap && dataMap.Yearly) {
        // If dataMap.Yearly is an object keyed by year, e.g. { 2012: 100, 2013: 200, ... }
        if (!Array.isArray(dataMap.Yearly)) {
          const mappedData = last12Years.map(year => dataMap.Yearly[year] || 0);
          setSeriesData(mappedData);
        } else {
          // If already an array, just set it (assuming correct order)
          setSeriesData(dataMap.Yearly);
        }
      } else {
        setSeriesData(new Array(12).fill(0));
      }
    } else if (period === "Monthly") {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      setCategories(months);
      setSeriesData(dataMap?.Monthly || new Array(12).fill(0));
    } else if (period === "Weekly") {
      const weeks = Array.from({ length: 12 }, (_, i) => `Week ${i + 1}`);
      setCategories(weeks);
      setSeriesData(dataMap?.Weekly || new Array(12).fill(0));
    } else if (period === "Today") {
      const now = moment();
      const hours = [];
      for (let i = 11; i >= 0; i--) {
        hours.push(now.clone().subtract(i, "hours").format("h A"));
      }
      setCategories(hours);
      setSeriesData(dataMap?.Today || new Array(12).fill(0));
    }
  }, [period, dataMap]);

  const chartOptions = {
    chart: { id: "message-analytics", toolbar: { show: false }, zoom: { enabled: false } },
    xaxis: { categories },
    dataLabels: { enabled: false },
    stroke: { curve: "smooth", width: 2 },
    colors: ["#008FFB"],
    tooltip: { enabled: true },
  };

  const chartSeries = [
    {
      name: "Messages Delivered",
      data: seriesData,
    },
  ];

  return (
    <div className="col-md-8">
      <div className="card h-100">
        <div className="card-body">
          <div className="d-flex flex-wrap align-items-center justify-content-between">
            <div>
              <h6 className="text-lg mb-0">Message Analytics</h6>
              <p>Message delivery performance over time</p>
            </div>
            <select
              className="form-select bg-base form-select-sm w-auto"
              value={period}
              onChange={(e) => setPeriod(e.target.value)}
            >
              <option value="Yearly">Yearly</option>
              <option value="Monthly">Monthly</option>
              <option value="Weekly">Weekly</option>
              <option value="Today">Today</option>
            </select>
          </div>
          <div className="d-flex flex-wrap align-items-center gap-2 mt-8">
            <h6 className="mb-0">{seriesData.reduce((a, b) => a + b, 0)}</h6>
            <span className="text-xs fw-medium">
              , {dataMap?.Today[dataMap?.Today.length - 1]} Current Hour
            </span>
          </div>
          <ReactApexChart options={chartOptions} series={chartSeries} type="area" height={264} />
        </div>
      </div>
    </div>
  );
};

export default MessageAnalytics;
